.page {
    min-height: 100vh;
    overflow-y: auto;
    background: var(--bg-dark); /* or white or whatever your app uses */
    box-sizing: border-box;
}

.header {
    padding-top: 90px;
}

.list {
    background-color: var(--bg-dark);
}

.filters {
    background-color: var(--bg-light);
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    max-width: 955px;
    gap: 10px;
    padding: 20px;
    margin: 50 auto 0;

    border: 1px solid var(--border);
    border-radius: 6px;
    box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.25);
}

.searchContainer {
    display: flex;
    min-width: 50%;
    max-width: 100%;
}

.searchInput {
    flex: 1;
    height: 32px;
    border: 1px solid;
    font-size: 14px;
    border-radius: 6px;
    padding: 10px;
}

.active:after {
    content: "\2212";
}

.categoryFilters {
    display: flex;
    flex: 2;
    flex-wrap: wrap;
    justify-content: flex-start;
    padding: 0 18px;
    max-height: 100%;
    overflow: hidden;
    transition: max-height 0.3s ease out;
}

.categoryLabel {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    margin-right: 12px;
    cursor: pointer;
    user-select: none;
}

.categoryImage {
    width: 25px;
    height: 25px;
    object-fit: cover;
}

.categoryCheckbox {
    cursor: pointer;
}

.card {
    min-height: 50px;
    padding: 14px 14px 20px 14px;
    background-color: var(--bg-light);
    border: 1px solid var(--border);
    border-radius: 6px;
    box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.25);
    cursor: pointer;
    display: flex;
    flex-direction: column;
    transition:
        transform 0.1s ease,
        box-shadow 0.1s ease;
}

.card:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 8px 0 rgba(0, 0, 0, 0.25);
}

.card > img {
    width: 142px;
    height: 142px;
}

@media (max-width: 456px) {
    .header {
        padding-top: 50px;
    }
    .filters {
        flex-direction: column;
        max-width: calc(100vw - 60px);
    }

    .card {
        min-height: 100%;
    }

    .card > img {
        width: 100%;
        height: auto;
        aspect-ratio: 1 / 1;
    }
}
